import { EMPTY_STRIPE, PENDING_STRIPE, ACTION_REQUIRED, READY_STRIPE, FRONT_STRIPE_STATUS } from '../constants/constants';

// eslint-disable-next-line import/prefer-default-export
export function getAccountStatus(status) {
  switch (true) {
  case EMPTY_STRIPE.includes(status):
    return FRONT_STRIPE_STATUS.EMPTY;
  case PENDING_STRIPE.includes(status):
    return FRONT_STRIPE_STATUS.PENDING;
  case ACTION_REQUIRED.includes(status):
    return FRONT_STRIPE_STATUS.ACTION_REQUIRED;
  case READY_STRIPE.includes(status):
    return FRONT_STRIPE_STATUS.READY;
  default:
    return null;
  }
}
